import type { AlimTalkTemplate } from "../../../api/services/notification-center.service";
import { isApprovedAlimTalkTemplate } from "./alimtalkTemplate";

export async function loadApprovedTemplates(fetchPage: (params: { status: string; page_size: number; page: number }) => Promise<{ data: { count: number; results: AlimTalkTemplate[] } | AlimTalkTemplate[] }>) {
  const templates = new Map<number, AlimTalkTemplate>();
  for (let page = 1; ; page += 1) {
    const { data } = await fetchPage({ status: "APR", page_size: 100, page });
    const rows = Array.isArray(data) ? data : data.results;
    const count = Array.isArray(data) ? data.length : data.count;
    const previousSize = templates.size;
    rows.forEach((template) => templates.set(template.id, template));
    if (templates.size >= count || !Number.isFinite(count)) return [...templates.values()].filter(isApprovedAlimTalkTemplate);
    if (templates.size === previousSize) throw new Error("템플릿 목록이 변경되었습니다. 다시 조회해 주세요.");
  }
}
